import script from "./PortfolioView.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioView.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioView.vue?vue&type=style&index=0&id=09fbb4f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09fbb4f8"]])

export default __exports__